import React from 'react';
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { QualityTableSkeleton, QualitySummaryCardsSkeleton } from "./QualityTableSkeleton";

export function GapManagementFullPageSkeleton() {
  return (
    <div className="overflow-x-hidden max-w-full">
      {/* Page Header Skeleton */}
      <div className="mb-4 flex items-center justify-between gap-2 opacity-0 animate-in fade-in-50"
        style={{
          animationDuration: '300ms',
          animationFillMode: 'forwards'
        }}>
        <Skeleton className="h-9 w-48" /> {/* Gap Management title */}
      </div>

      {/* Summary Cards (Composite + Category Cards) */}
      <QualitySummaryCardsSkeleton />

      {/* GapsToClose Component Skeleton */}
      <section className="mt-6 opacity-0 animate-in fade-in-50"
        style={{
          animationDelay: '200ms',
          animationDuration: '300ms',
          animationFillMode: 'forwards'
        }}>
        <Card>
          <CardHeader>
            <Skeleton className="h-6 w-32 mb-2" />
            <Skeleton className="h-4 w-64" />
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="flex items-center justify-between p-3 rounded-lg border">
                  <div className="space-y-2">
                    <Skeleton className="h-4 w-48" />
                    <Skeleton className="h-3 w-32" />
                  </div>
                  <Skeleton className="h-8 w-20 rounded-md" />
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </section>

      {/* Quality Summary Table Card Skeleton */}
      <section className="mt-8 opacity-0 animate-in fade-in-50"
        style={{
          animationDelay: '250ms',
          animationDuration: '300ms',
          animationFillMode: 'forwards'
        }}>
        <Card>
          <CardHeader>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <Skeleton className="h-7 w-40" /> {/* Quality Summary title */}
              <div className="flex flex-wrap items-center gap-2">
                {/* Control buttons skeleton */}
                <Skeleton className="h-8 w-24 rounded-md" />
                <Skeleton className="h-8 w-32 rounded-md" />
                <Skeleton className="h-8 w-40 rounded-md" />
              </div>
            </div>
          </CardHeader>
          <CardContent>
            {/* Filters skeleton */}
            <div className="mb-4 flex flex-wrap gap-2">
              <Skeleton className="h-10 w-32 rounded-md" />
              <Skeleton className="h-10 w-32 rounded-md" />
              <Skeleton className="h-10 w-24 rounded-md" />
            </div>
            
            {/* Table skeleton */}
            <div className="rounded-lg border">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="border-b">
                      <th className="p-3"><Skeleton className="h-4 w-4" /></th>
                      <th className="p-3"><Skeleton className="h-4 w-20" /></th>
                      <th className="p-3"><Skeleton className="h-4 w-32" /></th>
                      <th className="p-3"><Skeleton className="h-4 w-24" /></th>
                      <th className="p-3"><Skeleton className="h-4 w-16" /></th>
                      <th className="p-3"><Skeleton className="h-4 w-16" /></th>
                      <th className="p-3"><Skeleton className="h-4 w-16" /></th>
                      <th className="p-3"><Skeleton className="h-4 w-32" /></th>
                      <th className="p-3"><Skeleton className="h-4 w-16" /></th>
                      <th className="p-3"><Skeleton className="h-4 w-20" /></th>
                    </tr>
                  </thead>
                  <tbody>
                    <QualityTableSkeleton rows={8} />
                  </tbody>
                </table>
              </div>
            </div>

            {/* Bottom action buttons skeleton */}
            <div className="mt-4 flex flex-wrap items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <Skeleton className="h-10 w-32 rounded-md" />
                <Skeleton className="h-10 w-48 rounded-md" />
              </div>
              <Skeleton className="h-10 w-40 rounded-md" />
            </div>
          </CardContent>
        </Card>
      </section>
    </div>
  );
}
